// extracted by mini-css-extract-plugin
export var askAiIcon = "_q8-9";
export var container = "_q8-0";
export var groupSeparator = "_q8-a";
export var highlight = "_q8-4";
export var resultIcon = "_q8-5";
export var resultItem = "_q8-7";
export var resultSubtitle = "_q8-3";
export var resultTitle = "_q8-2";
export var resultsList = "_q8-1";
export var searchGroup = "_q8-6";
export var selected = "_q8-8";